import {
    Divider,
    IconButton,
    Popover,
    Typography,
} from '@material-ui/core';
import { DevicesRounded, PhonelinkOffRounded } from '@material-ui/icons';
import axios from 'axios';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { apiCatchBlockFunction, isValidTextAndNotEmpty } from '../constants/CommonUtil';
import API from '../constants/api';
import { getStringFromObject } from '../constants/lodashUtils';
import { isObjectValidAndNotEmpty } from '../constants/nullCheckUtils';
import { fetchMachineIdSilently, getRegisteredMachineDetails } from '../constants/registeredMachineUtils';
import { errorMessage, successMessage } from '../redux/modules/message/message-actions';
import { addRegisteredMachineDetails } from '../redux/modules/registeredMachine/registeredMachine-actions';
import { hideSpinner, showSpinner } from '../redux/modules/spinner/spinner';
import ActionButton from './ActionButton/ActionButton';

class RegisteredMachineIndicator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openPopover: false,
            iconButtonEl: null,
        };
    }

    handleIconClick = (event) => {
        this.setState({
            openPopover: true,
            iconButtonEl: event.currentTarget,
        });
    };

    handleClosePopover = () => {
        this.setState({
            openPopover: false,
            iconButtonEl: null,
        });
    };

    handleConnectClick = async () => {
        const { printConnectConfig, dispatch } = this.props;
        let registeredMachineDetails = getRegisteredMachineDetails();
        if (!isObjectValidAndNotEmpty(registeredMachineDetails)) {
            const machineId = await fetchMachineIdSilently(printConnectConfig);
            if (!isValidTextAndNotEmpty(machineId)) {
                dispatch(errorMessage('Unable to fetch machine id'));
                return;
            }
            try {
                dispatch(showSpinner());
                const response = await axios.get(API.REGISTERED_MACHINE.GET_DETAILS, {
                    params: {
                        machineId,
                    },
                });
                if (isObjectValidAndNotEmpty(response.data)) {
                    registeredMachineDetails = response.data;
                }
            } catch (error) {
                apiCatchBlockFunction(error, dispatch);
            } finally {
                dispatch(hideSpinner());
            }
        }
        if (isObjectValidAndNotEmpty(registeredMachineDetails)) {
            dispatch(successMessage('Connected Successfully'));
            dispatch(addRegisteredMachineDetails(registeredMachineDetails));
            this.handleClosePopover();
        }
    }

    render() {
        const { openPopover, iconButtonEl } = this.state;
        const { registeredMachine } = this.props;

        return (
            <React.Fragment>
                <IconButton
                    onClick={this.handleIconClick}
                    ref={this.popoverAnchor}
                    color="inherit"
                >
                    {
                        isObjectValidAndNotEmpty(registeredMachine) ? (
                            <DevicesRounded />
                        ) : (
                            <PhonelinkOffRounded color="error" />
                        )
                    }
                </IconButton>
                <Popover
                    open={openPopover}
                    anchorEl={iconButtonEl}
                    onClose={this.handleClosePopover}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    PaperProps={{
                        style: {
                            padding: 16,
                            minWidth: 260,
                            borderRadius: 8,
                        },
                    }}
                >
                    {
                        isObjectValidAndNotEmpty(registeredMachine) ? (
                            <div>
                                <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                    Registered Machine
                                </Typography>
                                <Divider style={{ margin: '8px 0' }} />
                                <div style={{ marginBottom: 8 }}>
                                    <Typography variant="caption" color="textSecondary">
                                        Name
                                    </Typography>
                                    <Typography variant="body1">
                                        {registeredMachine.name}
                                    </Typography>
                                </div>
                                <div style={{ marginBottom: 8 }}>
                                    <Typography variant="caption" color="textSecondary">
                                        Machine ID
                                    </Typography>
                                    <Typography
                                        variant="subtitle2"
                                        style={{ wordBreak: 'break-all' }}
                                    >
                                        {registeredMachine.machineId}
                                    </Typography>
                                </div>
                                <div>
                                    <Typography variant="caption" color="textSecondary">
                                        Code
                                    </Typography>
                                    <Typography variant="body1">
                                        {registeredMachine.code}
                                    </Typography>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <Typography variant="body1" color="textSecondary">
                                This machine is not registered.
                                </Typography>
                                <Divider style={{ margin: '8px 0' }} />
                                <div className="display-flex justify-content-right">
                                    <ActionButton onClick={this.handleConnectClick}>
                                    Connect
                                    </ActionButton>
                                </div>
                            </div>
                        )
                    }
                </Popover>
            </React.Fragment>
        );
    }
}

RegisteredMachineIndicator.propTypes = {
    dispatch: PropTypes.func.isRequired,
    registeredMachine: PropTypes.object.isRequired,
    printConnectConfig: PropTypes.object.isRequired,
};

RegisteredMachineIndicator.defaultProps = {

};

const mapStateToProps = state => ({
    registeredMachine: getStringFromObject('registeredMachine', state),
    printConnectConfig: getStringFromObject('appConfiguration.printConnectConfig', state),
});

export default connect(mapStateToProps)(RegisteredMachineIndicator);
